import { differenceInMilliseconds } from 'date-fns';
import { createSelector } from 'reselect';

import { getRoot } from 'utils/selectors';

import { getContextById, getContextByIds } from './context';
import { getUIState } from './general';

const getUIContext = createSelector(getUIState, state => state.details.context);

const getSelectState = createSelector(
  getUIContext,
  /** @returns {import("modules/global/reducers/simpleSearchReducer").SimpleSearchReducer} */
  state => state.select
);

export const getContextSelectIds = createSelector(getSelectState, state => state.ids);

export const getContextSelectPage = createSelector(getSelectState, state => state.page);

export const isContextSelectLoading = createSelector(getSelectState, state => state.loading);

export const hasMoreContextSelectEntries = createSelector(getSelectState, state => state.hasMore);

export const getContextSelectError = createSelector(getSelectState, state => state.error);

export const getContextSelectEntries = createSelector(getRoot, getContextSelectIds, getContextByIds);

const getSelectedContextId = createSelector(getUIContext, state => state.selected);

export const getSelectedContext = createSelector(getRoot, getSelectedContextId, getContextById);

const sortByModifiedOn = (a, b) => differenceInMilliseconds(a.modifiedOn, b.modifiedOn);

export const getLatestContext = createSelector(
  getContextSelectEntries,
  /** @returns {ConversationContext} */
  entities => entities.toSorted(sortByModifiedOn).pop()
);
